import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heterosexual: {
    id: 'InfoPso.heterosexual',
    defaultMessage: 'Heterosexual'
  },
  lesbian: {
    id: 'InfoPso.lesbian',
    defaultMessage: 'Lesbian'
  },
  gay: {
    id: 'InfoPso.gay',
    defaultMessage: 'Gay'
  },
  bisexual: {
    id: 'InfoPso.bisexual',
    defaultMessage: 'Bisexual'
  },
  queer: {
    id: 'InfoPso.queer',
    defaultMessage: 'Queer'
  },
  asexuals: {
    id: 'InfoPso.asexuals',
    defaultMessage: 'Asexuals'
  },
  pansexual: {
    id: 'InfoPso.pansexual',
    defaultMessage: 'Pansexual'
  },
  other: {
    id: 'InfoPso.other',
    defaultMessage: 'Other'
  },
  opt_out: {
    id: 'InfoPso.opt_out',
    defaultMessage: 'Opt Out'
  }
});

/** Códigos de orientação sexual gravados em applicant.pso. */
export const SEXUAL_ORIENTATION_MESSAGE_IDS = {
  A: messages.heterosexual.id,
  B: messages.lesbian.id,
  C: messages.gay.id,
  D: messages.bisexual.id,
  F: messages.queer.id,
  H: messages.asexuals.id,
  I: messages.pansexual.id,
  J: messages.other.id,
  OPTOUT: messages.opt_out.id
};

export function getSexualOrientationMessageId(value) {
  if (!value || value === 'no' || value === '--') return null;

  return SEXUAL_ORIENTATION_MESSAGE_IDS[value] || null;
}
